<template>
    <div class="envarea-section"
         v-bind:class="{ details: detailWindow }"
    >

        <!--<SolutionPreview-->
        <!--v-bind:curentSolution="curentSolution"-->
        <!--v-bind:curentEnvironment="curentEnvironment"-->
        <!--v-if="detailWindow"-->
        <!--v-on:solutionActivate="solutionActivate"-->
        <!--/>-->

        <div class="solution-block"
             v-bind:class="{ details: detailWindow, 'visible-detail-mob' : visibleDetailMob }"
        >
            <div class="arrow"
                 @click="showDetails"
            ></div>
            <SolutionDetails
                v-bind:curentSolution="curentSolution"
                v-bind:curentEnvironment="curentEnvironment"
                v-on:solutionActivate="solutionActivate"
                v-on:setHoverSolution="setHoverSolution"
                v-on:setShowPage="setShowPage"

            />
            <!--v-on:setVisibleDetailMob="setVisibleDetailMob"-->
            <!--v-if="detailWindow"-->
        </div>

        <div class="area-components" id="area-components"
             v-bind:class="{ animate: enableAnimate,'visible-detail-mob-area':visibleDetailMob }"
        >
            <div class="imagelem fadein"
                 v-bind:style="{
                     top:imgShift.top,
                     left:imgShift.left,
                     'background-image': 'url('+curentEnvironment.image_smart+')',
                 }"
            >
                <transition name="fade" appear>
                    <div class="imgfit"
                         v-bind:style="{
                             height: imgSize.height+'px',
                             width: imgSize.width + 'px',
                            'background-image': 'url('+curentEnvironment.image+')',
                         }"
                         v-bind:class="{ hidden :imageSmart}"
                         @click="solutionActivate()"
                    ></div>
                </transition>

                <div class="solution-pointer"
                     v-for="solution in curentEnvironment.solutions"
                     v-bind:style="{top:solution.position_y + '%', left:solution.position_x+'%'}"
                >
                    <span
                        v-bind:class="{ active: solution.id==curentSolution.id, details: detailWindow , hover: (hoverSolution==solution.id) }"
                        @click="solutionActivate(solution.id)"
                        :content="`${solution.title}`"
                        v-tippy="tippyParam(solution.position_x,solution.position_y)"
                    ></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import SolutionDetails from '@/components/SolutionDetails.vue'
    import SolutionPreview from '@/components/SolutionPreview.vue'


    export default {
        name: "AreaComponents",
        props: ['curentEnvironment', 'curentSolution', 'typeSol', 'displayType'],
        data() {
            return {
                visibleDetailMob: false,
                widthDesktop: 1200,
                widthTablet: 667,
                winSize: {},
                imageDefaultSize: {},
                imgShift: {left: '50%', top: '50%'},
                imgSize: {height: 0, width: 0},
                detailWindow: false, // false = close
                hoverSolution: false,
                areaScale: 1,
                areaCenter: false,
                enableAnimate: false,
                indexActiveSolution: 0,

            }
        },
        computed: {
            imageSrc: function () {
                if (this.typeSol) {
                    return this.curentEnvironment.image_smart
                } else {
                    return this.curentEnvironment.image
                }
            },
            imageSmart: function () {
                if (this.typeSol) {
                    return true;
                } else {
                    return false;
                }
            },

        },
        watch: {
            'visibleDetailMob'() {
                this.fitResize
            },
            'curentSolution'() {
                if (this.curentSolution == false) {
                    this.detailWindow = false;
                    this.areaScale = 1;
                } else {

                    if (this.displayType == 'desk') {
                        this.areaScale = 1.02;
                    } else if (this.displayType == 'tab') {
                        this.areaScale = 1.01;
                    } else {
                        this.areaScale = 1.2;
                    }
                }
                this.fitResize()
            },
            'displayType'() {
                if (this.displayType == 'mob' && !this.curentSolution && this.curentEnvironment.hasOwnProperty('solutions')) {
                    this.$emit('selectSolution', this.curentEnvironment.solutions[this.indexActiveSolution].id);
                }
            },
            'curentEnvironment'() {
                if (this.displayType == 'mob' && !this.curentSolution && this.curentEnvironment.hasOwnProperty('solutions')) {
                    this.$emit('selectSolution', this.curentEnvironment.solutions[this.indexActiveSolution].id);
                }
            }
        },
        created() {
            window.addEventListener("resize", this.winResise);

        },
        destroyed() {
            window.removeEventListener("resize", this.winResise);
        },
        mounted() {
            this.fitResize();
            window.addEventListener('load', () => {
                this.fitResize();
            })
            setTimeout(() => {
                this.enableAnimate = true;
            }, 350)

        },
        updated() {
            this.fitResize();
        },
        methods: {
            winResise() {
                this.enableAnimate = false;
                this.fitResize;
                this.enableAnimate = true;
                // setTimeout(this.fitResize,300);
            },
            tippyParam(position_x, position_y) {
                let prefix = 'top';
                if (position_y < 20) {
                    prefix = 'bottom'
                }
                if (position_x < 30) {
                    prefix = prefix + '-start';
                } else if (position_x > 80) {
                    prefix = prefix + '-end';
                }
                let param = {
                    // trigger : "click",
                    hideOnClick: true,
                    interactive: true,
                    placement: prefix,
                    arrow: true,
                    animation: 'fade'
                };
                return param;
            },
            fitResize() {
                this.winSize = this.getWinSize();

                if (this.winSize.x <= this.widthTablet) {
                    if (!this.curentSolution && this.curentEnvironment.hasOwnProperty('solutions')) {
                        this.$emit('selectSolution', this.curentEnvironment.solutions[this.indexActiveSolution].id);
                    }
                    this.$emit('setDesktopSize', 'mob')
                } else if (this.winSize.x <= this.widthDesktop) {
                    this.$emit('setDesktopSize', 'tab')
                } else {
                    this.$emit('setDesktopSize', 'desk')
                }
                let aSol = this.getCoordinateActiveSolution();
                let center = {
                    x: 50,
                    y: 50,
                }
                if (typeof aSol != "undefined") {
                    center.x = aSol.position_x
                    center.y = aSol.position_y
                }

                var imgX = new Image();
                var imgNewWidth = 0;
                var imgNewHeight = 0;
                imgX.onload = () => {
                    this.imageDefaultSize.width = imgX.width;
                    this.imageDefaultSize.height = imgX.height;
                    // var img = document.getElementById('imgfit');

                    this.areaSize = this.getAreaSize();

                    let displayTypeShift = 0;
                    if (this.displayType == 'desk') {
                        displayTypeShift = 356;
                    }

                    // calculate image size
                    if ((this.areaSize.x) / this.imageDefaultSize.width > this.areaSize.y / this.imageDefaultSize.height) {
                        imgNewWidth = this.areaSize.x;
                        imgNewHeight = this.imageDefaultSize.height * (this.areaSize.x) / this.imageDefaultSize.width
                    } else {
                        imgNewHeight = this.areaSize.y
                        imgNewWidth = this.imageDefaultSize.width * this.areaSize.y / this.imageDefaultSize.height;
                    }


                    imgNewWidth = imgNewWidth * this.areaScale;
                    imgNewHeight = imgNewHeight * this.areaScale;

                    // img.style.height = imgNewHeight + "px";
                    // img.style.width = imgNewWidth + "px";

                    this.imgSize.height = imgNewHeight;
                    this.imgSize.width = imgNewWidth;
                    // calculate image central shift
                    let imgShiftLeft = 0;
                    let imgShiftTop = 0;


                    if (imgNewWidth > this.areaSize.x) {
                        if (center.x < 50) {
                            imgShiftLeft = Math.round((this.areaSize.x) / 2 - imgNewWidth * center.x / 100);

                            if (imgShiftLeft > displayTypeShift) {
                                imgShiftLeft = displayTypeShift;
                            } else if (imgShiftLeft < 0) {
                                imgShiftLeft = 0
                            }

                        } else if (center.x > 50) {
                            imgShiftLeft = Math.round(this.areaSize.x / 2 - imgNewWidth * center.x / 100);
                            if (imgShiftLeft < (this.areaSize.x - imgNewWidth)) {
                                imgShiftLeft = this.areaSize.x - imgNewWidth
                            }
                        } else {
                            imgShiftLeft = -1 * (imgNewWidth - this.areaSize.x) / 2
                        }
                    }


                    if (imgNewHeight > this.areaSize.y) {
                        if (center.y < 50) {
                            imgShiftTop = Math.round(this.areaSize.y / 2 - imgNewHeight * center.y / 100);
                            if (imgShiftTop > 0) {
                                imgShiftTop = 0;
                            }
                        } else if (center.y > 50) {
                            imgShiftTop = Math.round(this.areaSize.y / 2 - imgNewHeight * center.y / 100);
                            if (imgShiftTop < (this.areaSize.y - imgNewHeight)) {
                                imgShiftTop = this.areaSize.y - imgNewHeight
                            }
                        } else {
                            imgShiftTop = -1 * (imgNewHeight - this.areaSize.y) / 2
                        }

                    }

                    //
                    this.imgShift.left = imgShiftLeft+'px';
                    this.imgShift.top = imgShiftTop+'px';

                }


                imgX.src = this.curentEnvironment.image;

            },
            getAreaSize() {
                var area = document.getElementById("area-components");
                return {
                    x: area.innerWidth || area.clientWidth,
                    y: area.innerHeight || area.clientHeight
                }

            },
            getWinSize() {
                var body = document.documentElement || document.body;
                return {
                    x: (window.innerWidth) || (body.clientWidth),
                    y: window.innerHeight || body.clientHeight
                }
            },
            showDetails() {
                this.detailWindow = !this.detailWindow;
                if (this.detailWindow == false && this.displayType != 'mob') {
                    this.$emit('selectSolution', false);
                } else {
                    if (this.curentSolution == false) {
                        this.$emit('selectSolution', this.curentEnvironment.solutions[this.indexActiveSolution].id);
                    }
                }
            },
            solutionActivate(sol_id) {

                if (this.displayType != 'mob') {
                    this.$emit('selectSolution', sol_id);
                    if (sol_id) {
                        this.detailWindow = true;
                    } else {
                        this.detailWindow = false;
                    }
                } else if (sol_id) {
                    this.$emit('selectSolution', sol_id);
                }
            },
            setHoverSolution(sol_id) {
                this.hoverSolution = sol_id;
            },
            getCoordinateActiveSolution() {

                if (this.curentSolution) {
                    let sol = this.curentEnvironment.solutions.find((el) => {
                        return el.id == this.curentSolution.id;
                    })
                    return sol;
                }
                return false;

            },
            // setVisibleDetailMob(status){
            //     this.visibleDetailMob = status;
            // },
            setShowPage(page) {
                this.$emit('setShowPage', page)
            },

        },
        components: {
            SolutionDetails, SolutionPreview
        }
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all 0.5s ease-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

</style>